<nb-card class="preview-modal">

  <nb-card-header>
    <b>Preview Dokumen</b>
  </nb-card-header>

  <nb-card-body class="preview-body">

    <!-- IMAGE -->
    <img *ngIf="isImage" [src]="file" class="preview-img-full" />

    <!-- PDF -->
    <iframe *ngIf="isPdf" [src]="safePdfUrl" class="preview-pdf"></iframe>

    <div *ngIf="!file" class="text-muted">
      Tidak ada dokumen
    </div>

  </nb-card-body>

  <nb-card-footer>
    <button nbButton status="basic" (click)="close()">
      Tutup
    </button>
  </nb-card-footer>

</nb-card>
